import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StWorkOrderService extends ApiService {

    index(params: any): Observable<any> {
        return super.get('/st-work-orders', params);
    }

    show(stWorkOrderId: number): Observable<any> {
        return super.get(`/st-work-orders/${stWorkOrderId}`);
    }

    store(body: any) {
        return super.post(`/st-work-orders`, body);
    }

    edit(stWorkOrderId: number, params: any = {}) {
        return super.get(`/st-work-orders/${stWorkOrderId}/edit`, params);
    }

    update(stWorkOrderId: number, body: any) {
        return super.put(`/st-work-orders/${stWorkOrderId}`, body);
    }

    destroy(stWorkOrderId: number) {
        return super.delete(`/st-work-orders/${stWorkOrderId}`);
    }

    send(stWorkOrderIds: number[]) {
        return super.post(`/st-work-orders/send`, { work_order_ids: stWorkOrderIds });
    }
}
